import { useState } from 'react';
import styled from 'styled-components';

import { Portal } from '@sorare/core/src/atoms/layout/Portal';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { FiltersDrawer } from '@sorare/core/src/components/FiltersDrawer';
import { FilterButton } from '@sorare/core/src/components/search/FilterButton';
import {
  SearchLayoutContainer,
  VerticalScroll,
} from '@sorare/core/src/components/search/SearchLayout/ui';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

interface Props {
  children: React.ReactNode;
  toolbar?: React.ReactNode;
}

const ButtonContainer = styled(Horizontal)`
  margin-bottom: var(--double-unit);
`;

const StyledDrawer = styled(FiltersDrawer)`
  background: var(--c-black);
  width: 100%;
  padding: var(--double-unit) 0;
  --radio-padding: var(--unit);
  --c-radio-bg: transparent;
  @media ${tabletAndAbove} {
    width: 320px;
  }
`;

const StyledFilterButton = styled(FilterButton)`
  margin: 0;
`;

const Sidebar = styled(VerticalScroll)`
  min-width: 320px;
  padding-right: 0;
  --radio-padding: var(--unit);
  --c-radio-bg: transparent;
`;

const Main = styled.div`
  width: 100%;
  padding: 0 var(--double-unit);
`;

export const MyPage = ({ children, toolbar }: Props) => {
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
  const isDesktopAndAbove = useIsLaptop();
  return (
    <>
      {!isDesktopAndAbove && !!toolbar && (
        <Portal id="above-bottom-bar-portal">
          <ButtonContainer center>
            {!!toolbar && (
              <StyledFilterButton
                className="center"
                onClick={() => setShowFiltersDrawer(true)}
              />
            )}
          </ButtonContainer>
        </Portal>
      )}
      <StyledDrawer
        open={showFiltersDrawer}
        onClose={() => setShowFiltersDrawer(false)}
      >
        {toolbar}
      </StyledDrawer>
      <SearchLayoutContainer>
        {!!isDesktopAndAbove && !!toolbar && (
          <Sidebar>
            <Vertical>{toolbar}</Vertical>
          </Sidebar>
        )}
        <Main>{children}</Main>
      </SearchLayoutContainer>
    </>
  );
};
